import React, { useState } from "react";
import LowStockView from "./LowStockView";
import EditIcon from "@mui/icons-material/Edit";
import EditLowStockModal from "../../utility/EditLowStockModal";
import { useMutation } from "@tanstack/react-query";
import { updateData } from "../../utility/managerApi";
import ImageWithPlaceholder from "../../components/ImageWithPlaceholder";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function LowStockTableBody({ lowstockData, currency }) {
  const [newData, setNewData] = useState({});
  const [editTab, setEditTab] = useState(false);

  const handleEdit = (item) => {
    setNewData(item);
    setEditTab(true);
  };

  const updateStock = useMutation({
    mutationFn: (data) => updateData("products/update/", data?.id, data),
    onSuccess: () => {
      setEditTab(false);
    },
  });

  const handleSubmit = (data) => {
    updateStock.mutate(data);
  };

  return (
    <>
      <tbody>
        {lowstockData?.map((item) => (
          <tr
            key={item?.id}
            className="hover:bg-gray-100 border-b border-gray-300"
          >
            <td className="py-2  flex justify-center">
              <ImageWithPlaceholder
                item={item}
                className="w-10 h-10 rounded-md object-cover"
                placeholderClassName="w-10 h-10 bg-slate-400 text-white flex justify-center font-medium items-center rounded-md text-xl"
              />{" "}
            </td>
            <td className="py-2 px-4 text-center text-wrap">
              {item?.product_name}
            </td>
            <td className="py-2 px-4 text-center text-wrap">
              {item?.available_quantity}
            </td>
            <td className="py-2 px-4 text-center text-wrap">
              {currency} {formatNumbersWithDecimal(item?.price)}
            </td>

            <td className="py-2 px-4 text-center text-wrap">
              {item?.category?.cat_name}
            </td>
            <td className="py-2 px-4 text-center flex justify-center   gap-3 text-wrap">
              <EditIcon
                onClick={() => handleEdit(item)}
                className="text-blue-500 cursor-pointer"
              />
              <LowStockView item={item} currency={currency} />
            </td>
          </tr>
        ))}
      </tbody>
      {editTab && (
        <EditLowStockModal
          newData={newData}
          setEditTab={setEditTab}
          setNewData={setNewData}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
}

export default LowStockTableBody;
